export enum CreateModifyTiers {
  TIER_0 = 'tier0',
  TIER_1 = 'tier1',
  TIER_2 = 'tier2',
}
